import React, { useEffect, useState } from 'react';

/* ─── Theme map — matches School.jsx THEMES ─────────────────────────────────
   Pass `themeId` prop (1 or 2) from the parent to pick the right palette.
   Falls back to a neutral green if not passed (works for Register page too).
─────────────────────────────────────────────────────────────────────────── */
const THEMES = {
   1: {                          // +2 — forest green
    overlay:    'rgba(7,18,9,0.7)',
    cardBg:     '#ffffff',
    headerBg:   'linear-gradient(135deg,#f0fdf4 0%,#dcfce7 100%)',
    headerBorder:'#bbf7d0',
    accent:     '#4ade80',
    accentDim:  'rgba(74,222,128,0.12)',
    iconBg:     '#f0fdf4',
    iconColor:  '#16a34a',
    titleColor: '#14532d',
    textColor:  '#374151',
    itemBorder: '#d1fae5',
    itemBg:     '#f9fffe',
    itemAccent: '#16a34a',
    btnBg:      '#16a34a',
    btnHov:     '#15803d',
    footerText: '#64748b',
  },
  2: {                          // CTG Vidya Mandir — royal purple
    overlay:    'rgba(18,8,42,0.65)',
    cardBg:     '#ffffff',
    headerBg:   'linear-gradient(135deg,#f5f3ff 0%,#ede9fe 100%)',
    headerBorder:'#ddd6fe',
    accent:     '#7c3aed',
    accentDim:  'rgba(124,58,237,0.1)',
    iconBg:     '#f5f3ff',
    iconColor:  '#6d28d9',
    titleColor: '#3b0764',
    textColor:  '#374151',
    itemBorder: '#ede9fe',
    itemBg:     '#faf9ff',
    itemAccent: '#7c3aed',
    btnBg:      '#7c3aed',
    btnHov:     '#6d28d9',
    footerText: '#6b7280',
  },

  3: {                          // Professional — black / gold
    overlay:    'rgba(0,0,0,0.75)',
    cardBg:     '#111111',
    headerBg:   'linear-gradient(135deg,#1a1400 0%,#2a2000 100%)',
    headerBorder:'rgba(212,170,80,0.3)',
    accent:     '#d4aa50',
    accentDim:  'rgba(212,170,80,0.12)',
    iconBg:     '#1c1608',
    iconColor:  '#d4aa50',
    titleColor: '#fcd34d',
    textColor:  '#fef9ec',
    itemBorder: 'rgba(212,170,80,0.2)',
    itemBg:     '#161616',
    itemAccent: '#d4aa50',
    btnBg:      '#b45309',
    btnHov:     '#92400e',
    footerText: 'rgba(212,170,80,0.6)',
  },
  default: {                    // Register page / fallback — green
    overlay:    'rgba(0,0,0,0.5)',
    cardBg:     '#ffffff',
    headerBg:   'linear-gradient(135deg,#f0fdf4 0%,#dcfce7 100%)',
    headerBorder:'#bbf7d0',
    accent:     '#16a34a',
    accentDim:  'rgba(22,163,74,0.1)',
    iconBg:     '#f0fdf4',
    iconColor:  '#15803d',
    titleColor: '#14532d',
    textColor:  '#374151',
    itemBorder: '#dcfce7',
    itemBg:     '#f9fffe',
    itemAccent: '#16a34a',
    btnBg:      '#16a34a',
    btnHov:     '#15803d',
    footerText: '#6b7280',
  },
};

const Notification = ({ IsSuccess, handleClose, title, msgList, isAlumni, themeId }) => {
  const t = THEMES[themeId] || THEMES.default;
  const [hov, setHov] = useState(false);
  const [visible, setVisible] = useState(false);

  // useEffect(() => {
  //   if (IsSuccess) setTimeout(() => setVisible(true), 10);
  //   else setVisible(false);
  // }, [IsSuccess]);

  useEffect(() => {
    if (IsSuccess) setTimeout(() => setVisible(true), 10);
    else setVisible(false);
  }, [IsSuccess]);

  if (!IsSuccess) return null;
debugger
  return (
    <div style={{
      position:'fixed', inset:0, zIndex:9999,
      background: t.overlay,
      display:'flex', alignItems:'center', justifyContent:'center',
      padding:'1rem',
      opacity: visible ? 1 : 0,
      transition:'opacity 0.25s ease',
    }}>
      <div style={{
        background: t.cardBg,
        borderRadius:20,
        width:'100%', maxWidth:460,
        boxShadow:'0 24px 60px rgba(0,0,0,0.18)',
        overflow:'hidden',
        transform: visible ? 'translateY(0) scale(1)' : 'translateY(20px) scale(0.97)',
        transition:'transform 0.3s cubic-bezier(0.34,1.56,0.64,1)',
      }}>

        {/* Header */}
        <div style={{
          background: t.headerBg,
          borderBottom:`1px solid ${t.headerBorder}`,
          padding:'24px 24px 20px',
          textAlign:'center',
        }}>
          {/* Success icon */}
          <div style={{
            width:56, height:56, borderRadius:'50%',
            background: t.iconBg,
            border:`2px solid ${t.accent}`,
            display:'flex', alignItems:'center', justifyContent:'center',
            margin:'0 auto 14px',
            boxShadow:`0 0 0 6px ${t.accentDim}`,
          }}>
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none"
              stroke={t.iconColor} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="20 6 9 17 4 12" />
            </svg>
          </div>
          <h2 style={{
            margin:0, fontSize:18, fontWeight:700,
            color: t.titleColor,
            fontFamily:"'DM Sans','Segoe UI',sans-serif",
            letterSpacing:'-0.01em',
          }}>{title}</h2>
        </div>

        {/* Body — message list */}
        <div style={{ padding:'20px 24px' }}>
          {(msgList || []).map((item, i) => (
            <div key={i} style={{
              display:'flex', alignItems:'flex-start', gap:10,
              padding:'11px 14px',
              background: t.itemBg,
              border:`1px solid ${t.itemBorder}`,
              borderRadius:10,
              marginBottom: i < msgList.length - 1 ? 8 : 0,
            }}>
              <span style={{
                width:6, height:6, borderRadius:'50%',
                background: t.itemAccent,
                flexShrink:0, marginTop:7,
              }} />
              <p style={{
                margin:0, fontSize:14, color: t.textColor,
                lineHeight:1.6,
                fontFamily:"'DM Sans','Segoe UI',sans-serif",
              }}>{item}</p>
            </div>
          ))}
        </div>

        {/* Footer */}
        <div style={{
          padding:'0 24px 22px',
          display:'flex', flexDirection:'column', alignItems:'center', gap:12,
        }}>
          {!isAlumni && (
            <p style={{
              margin:0, fontSize:13, color: t.footerText,
              textAlign:'center', fontStyle:'italic',
              fontFamily:"'DM Sans','Segoe UI',sans-serif",
            }}>
              Thank you for showing interest in CTG 🎓
            </p>
          )}
          <button
            onMouseEnter={() => setHov(true)}
            onMouseLeave={() => setHov(false)}
            onClick={handleClose}
            style={{
              padding:'10px 40px', borderRadius:10, border:'none',
              background: hov ? t.btnHov : t.btnBg,
              color:'#fff', fontWeight:600, fontSize:14,
              cursor:'pointer', letterSpacing:'0.04em',
              transition:'background 0.18s',
              fontFamily:"'DM Sans','Segoe UI',sans-serif",
              width:'100%',
            }}>
            OK, Got it
          </button>
        </div>
      </div>
    </div>
  );
};

export default Notification;